import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const SuccessStories = () => {
  const [alumni, setAlumni] = useState([]);

  useEffect(() => {
    fetch("https://ethiccraft.org/backend/valumni/read_isShown.php")
      .then((res) => res.json())
      .then((data) => {
        const parsedData = data.map((item) => {
          let tagsArray = [];
          try {
            if (item.tags?.startsWith("{") && item.tags?.endsWith("}")) {
              tagsArray = item.tags
                .replace(/[{}"]/g, "")
                .split(",")
                .map((tag) => tag.trim());
            } else {
              tagsArray = JSON.parse(item.tags);
            }
          } catch {
            tagsArray = [];
          }
          return { ...item, tags: tagsArray };
        });
        setAlumni(parsedData);
      })
      .catch((error) => {
        console.error("Failed to fetch alumni data:", error);
      });
  }, []);

  return (
    <div className="success-container">
      <div className="intro-section">
        <motion.h2
          className="main-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          Our Alumni
        </motion.h2>
      </div>

      <div className="case-section">
        {alumni.map((item, index) => (
          <div className="case-card" key={index}>
            {item.image && (
              <img
                src={`https://ethiccraft.org/${item.image}`}
                className="case-img"
                alt={item.name || "Alumni image"}
                onError={(e) => {
                  e.target.onerror = null;
                }}
              />
            )}

            <div className="case-content">
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              {item.tags && (
                <div className="tags">
                  {item.tags.map((tag, i) => (
                    <span key={i}>{tag}</span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuccessStories;
